var map = {
	"./ServicesReservationsCalendar.svg": "8ff7",
	"./Thermometer.svg": "566c",
	"./absence-plans.svg": "63fb",
	"./active-substance.svg": "25e0",
	"./add-attendance.svg": "6b56",
	"./add-departure.svg": "8836",
	"./addUser.svg": "bd85",
	"./added-services-add.svg": "3bb1",
	"./added-services.svg": "afb6",
	"./address.svg": "597a",
	"./alert.svg": "49bb",
	"./allowances-daily-plans.svg": "7e59",
	"./allowances-plans.svg": "a71c",
	"./allowances.svg": "bbc4",
	"./anatomy-types.svg": "839c",
	"./anatomy.svg": "96d3",
	"./approve-cancel-reservation.svg": "7a4d",
	"./approve-reservation.svg": "2bcd",
	"./attend-reservation.svg": "4e21",
	"./attendance.svg": "b007",
	"./attendanceHistory.svg": "da0b",
	"./balances-plans.svg": "e340",
	"./banks.svg": "75c8",
	"./bg-01.jpg": "33da",
	"./blood-types.svg": "1936",
	"./branches.svg": "bbcf",
	"./buildings.svg": "95db",
	"./cancel-reservation.svg": "4260",
	"./cancel.svg": "541d",
	"./category.svg": "54d0",
	"./chambers.svg": "a1f9",
	"./changePassword.svg": "8d77",
	"./checkmark.svg": "f2fa",
	"./citizenship.svg": "dbb2",
	"./city.svg": "caa0",
	"./clients.svg": "90ee",
	"./code.svg": "2186",
	"./colors.svg": "46c2",
	"./complaint.svg": "7b21",
	"./country.svg": "0901",
	"./date.svg": "9bcd",
	"./dateAndTime.svg": "47fe",
	"./days.svg": "8ef3",
	"./description.svg": "ec2e",
	"./details.svg": "4056",
	"./diagnosis-plans-x.svg": "17e9",
	"./diagnosis-plans.svg": "2cb5",
	"./diagnosis.svg": "8c05",
	"./disease.svg": "6282",
	"./diseases.svg": "3b5d",
	"./district.svg": "7e17",
	"./doctor-notes-x.svg": "b6cf",
	"./doctor-notes.svg": "4d54",
	"./doctors.svg": "a74f",
	"./drivingLicense.svg": "ccf6",
	"./earth.svg": "cb65",
	"./email.svg": "7711",
	"./employee-salary-setting.svg": "3345",
	"./employees.svg": "91d3",
	"./enter-reservation.svg": "be5d",
	"./establishment.svg": "57b6",
	"./expenses-types-x.svg": "ab5e",
	"./expenses-types.svg": "a6bb",
	"./expenses.svg": "9ccb",
	"./eye-hide.svg": "4775",
	"./eye-show.svg": "c159",
	"./family.svg": "7bb6",
	"./filter.svg": "b05f",
	"./finance.svg": "10bd",
	"./finish-reservation.svg": "9471",
	"./floors.svg": "4557",
	"./gender.svg": "8bcb",
	"./general-specialities.svg": "0018",
	"./governate.svg": "f308",
	"./habits.svg": "baf6",
	"./heartRate.svg": "0c5d",
	"./historicalPlans-x.svg": "195f",
	"./historicalPlans.svg": "b60f",
	"./holiday.svg": "22b3",
	"./homepage.svg": "8cf7",
	"./hours.svg": "19bc",
	"./illustrator-forgot-password.svg": "7695",
	"./illustrator-login.svg": "2a0f",
	"./illustrator-mission.svg": "8edc",
	"./illustrator-noData.svg": "514c",
	"./illustrator-task.svg": "c515",
	"./illustrator-vision.svg": "e791",
	"./illustrator-work-time.svg": "1590",
	"./illustrator-work.svg": "8078",
	"./info-dark.svg": "67c4",
	"./info.svg": "db39",
	"./insurance-companies.svg": "da5d",
	"./insuranceCompanyService.svg": "c384",
	"./insurances-plans.svg": "84cb",
	"./insurances.svg": "5f53",
	"./jobs.svg": "e241",
	"./kilometer.svg": "d20a",
	"./kilometer2.svg": "4cf2",
	"./kilometer3.svg": "be8f",
	"./lang-ar.svg": "5b39",
	"./lang-en.svg": "b888",
	"./latitude.svg": "3432",
	"./length.svg": "7480",
	"./location.svg": "3589",
	"./logo.png": "9d64",
	"./logout.svg": "4488",
	"./longitude.svg": "5fe3",
	"./main-columns.svg": "2c27",
	"./man.svg": "eb6f",
	"./maritalStatus.svg": "9a34",
	"./maxDiscountPercentage.svg": "b1ae",
	"./meal.svg": "9bea",
	"./meals-types.svg": "a1f5",
	"./measurement-rooms-x.svg": "1956",
	"./measurement-rooms.svg": "1f0e",
	"./media.svg": "0500",
	"./medical-operations-x.svg": "7db1",
	"./medical-operations.svg": "b8ee",
	"./medical-prescription.svg": "3066",
	"./medical-rays-x.svg": "2af3",
	"./medical-rays.svg": "c0e8",
	"./medical-tests-x.svg": "2901",
	"./medical-tests.svg": "d32f",
	"./medicalInsuranceLevel.svg": "f901",
	"./medication-quantity.svg": "da1e",
	"./medicines-types.svg": "1467",
	"./medicines.svg": "6ec8",
	"./merge.svg": "f0dc",
	"./method-paids.svg": "0984",
	"./militaryStatus.svg": "b1d8",
	"./minutes.svg": "59e4",
	"./mode-dark.svg": "be60",
	"./mode-light.svg": "e7c3",
	"./money.svg": "095c",
	"./month-allowances-plans.svg": "1eb2",
	"./months-settings.svg": "0ce7",
	"./movement.svg": "8d1d",
	"./nationalNumber.svg": "1f8b",
	"./news-defult-img.svg": "f16c",
	"./news.svg": "8025",
	"./notes.svg": "bf2f",
	"./notifications.svg": "8b0c",
	"./number.svg": "80e1",
	"./offers.svg": "1541",
	"./office-time.svg": "9d23",
	"./office.svg": "8de2",
	"./official-holidays-plans.svg": "8bef",
	"./overtime-plans.svg": "7fe3",
	"./passportNumber.svg": "f6c8",
	"./passwordlock.svg": "8600",
	"./pay.svg": "46d6",
	"./payment-method.svg": "8423",
	"./payroll.svg": "da48",
	"./pdf.svg": "5fe9",
	"./pencil.svg": "68e3",
	"./percentage.svg": "4be0",
	"./phone-landline.svg": "eef0",
	"./phone.svg": "cf63",
	"./plus.svg": "5860",
	"./points-wallets.svg": "7073",
	"./points.svg": "dbc9",
	"./pressure.svg": "45c0",
	"./price-offer.svg": "ac89",
	"./privileges.svg": "d3d9",
	"./qualifications.svg": "0fb7",
	"./questions-x.svg": "4b47",
	"./questions.svg": "3ec3",
	"./reason.svg": "465a",
	"./receipt.svg": "b7cd",
	"./receiptWithTax.svg": "7958",
	"./refund.svg": "9d70",
	"./relative-relation.svg": "4a7ba",
	"./report.svg": "3c8a",
	"./reports.svg": "c387",
	"./reportsAndStatistics.svg": "fbd7",
	"./requirement-types.svg": "d2f5",
	"./requirements.svg": "d4bc",
	"./reservations-followed-add.svg": "c6ee",
	"./reservations-followed.svg": "af53",
	"./revenues-types-x.svg": "afdd",
	"./revenues-types.svg": "c14c",
	"./revenues.svg": "1fad",
	"./salary-effects.svg": "881a",
	"./salary-settings.svg": "faec",
	"./scientific-degrees.svg": "1c4b",
	"./search.svg": "22ee",
	"./seconds.svg": "8fbb",
	"./sectors.svg": "7c7d",
	"./serviceResponsibleBonuse.svg": "cc65",
	"./services-defalut.svg": "fdc6",
	"./services-payments.svg": "dee9",
	"./services-reservations.svg": "9789",
	"./services-types.svg": "64ca",
	"./services.svg": "0961",
	"./servicesReservationEmployeeBenefit.svg": "ea17",
	"./settings-additional.svg": "92b4",
	"./settings-establishment.svg": "7cdb",
	"./settings-general.svg": "437d",
	"./settings-other.svg": "cbba",
	"./settings-salary.svg": "ce6f",
	"./settings.svg": "09a5",
	"./sheets.svg": "ba9c",
	"./slices.svg": "b5cd",
	"./slider1.gif": "0d04",
	"./slider2.gif": "528e",
	"./slider3.gif": "c33c",
	"./slider4.gif": "eb72",
	"./special-spcialities.svg": "e769",
	"./statistics.svg": "2356",
	"./stores.svg": "99c9",
	"./suger.svg": "0999",
	"./symptoms.svg": "8684",
	"./sync.svg": "7e44",
	"./syndrome.svg": "dc57",
	"./time.svg": "56de",
	"./trash.svg": "311a",
	"./treasuries-transactions.svg": "7740",
	"./treasuries.svg": "0909",
	"./treatmentPlan-x.svg": "b909",
	"./treatmentPlan.svg": "7249",
	"./treatments-reservation.svg": "7c732",
	"./treatments.svg": "6265",
	"./type.svg": "bdf5",
	"./user.jpg": "3810",
	"./user.svg": "c9d8",
	"./verification-code.svg": "b5ec",
	"./video-camera.svg": "463c",
	"./waiting-back.svg": "bfa1",
	"./wallet.svg": "b23e",
	"./warning-x.svg": "7ec3",
	"./warning.svg": "e4db",
	"./weight.svg": "70d6",
	"./work-plan-days.svg": "05be",
	"./work-plans.svg": "ddb4",
	"./work-schedule.svg": "f95f",
	"./work-shifts.svg": "98b4",
	"./year-settings.svg": "9d2a",
	"./year.svg": "5f60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";